<template>
   <div class="login-bg">
    <div class="login">
      <transition name="slide-fade">
        <el-card class="box-card login-box" >
            <el-form
            label-position="top"
            :rules="rules"
            :model="selectedObject"
            ref="my-form"
            @submit.prevent="save"
            >
                <el-form-item prop="NewPassword" label="Parola noua">
                    <el-input autofocus
                    show-password
                    v-model="selectedObject.NewPassword"
                    />
                </el-form-item>
                <el-form-item prop="NewPassword2" label="Repeta parola noua">
                    <el-input
                    show-password
                    v-model="selectedObject.NewPassword2"
                />
                </el-form-item>
                <el-form-item>
                    <el-button type="success" @click="save"> Salveaza </el-button>
                </el-form-item>
            </el-form>
        </el-card>
    </transition>
    </div>
  </div>
</template>

<script>
    import settings from "@/backend/LocalSettings";
    import Vue from 'vue'

    export default {
        name: "Parola_noua",
        data () {
            var checkPass = (rule, value, callback) => {
      if (value == "" || value.length < 0) {
        callback(new Error("Campul este obligatoriu"));
      } else {
        let base = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])[A-Za-z\d\W_]{8,32}$/;
        if (!value.match(base)) {
          callback(
            new Error(
              "Parola trebuie sa contina cel putin 8 caractere, o litera mare, o litera mica, o cifra si un caracter special"
            )
          );
        } else {
          callback();
        }
      }
    };

    var samePass = (rule, value, callback) => {
      if (value == "" || value.length < 0) {
        callback(new Error("Campul este obligatoriu"));
      } else {
        if (value !== this.selectedObject.NewPassword) {
          callback(new Error("Cele doua parole nu corespund"));
        } else {
          callback();
        }
      }
    };
            return {
                token: "",
                selectedObject: {
                    NewPassword: "",
                    NewPassword2: "",
                },
                rules: {
                    NewPassword: [{ validator: checkPass, trigger: ["blur", "change"] }],
                    NewPassword2: [{ validator: samePass, trigger: "change" }],
                },
            }
        },
        async mounted() {
            // console.log('Merge')
            // console.log(this.$route.params)
            this.verificaToken();
        },
        methods: {
    
    verificaToken: async function() {
      var response = await this.post('utilizatori/check_change_password', { token: this.$route.params.token } );
      // console.log(response)
      if( response.Success == null ){
        this.$router.push("/no-rights");
        return;
      }
    },
    post: async function(url, args={}){
      this.loadingVisible      = true;
      var response             = await this.$http.post(url, args );
      this.loadingVisible      = false;
      if( settings.verify_response(response) ) return response.body;
    },
    save: async function () {
        this.$refs["my-form"].validate(async (valid) => {
            if (valid) {
                var response = await this.post('utilizatori/reset_forgotten_password', {info: this.selectedObject, token: this.$route.params.token });
                if (response.Success == 1) {
                    this.$message({type: 'success', message: 'Parola a fost schimbata cu succes'});
                     setTimeout(() => {
                        this.$router.push("/");  
                    }, 1000)  
                } else {
                    this.$message({type: 'error', message:'A intervenit o eroare in procesul schimbarii parolei'});
                }
            }
        })
    },
   
  },
    }
</script>

<style lang="less" scoped>

.login-box {
  margin: 50px auto;
  width: 320px;
}

.slide-fade-enter-active {
  transition: all 1.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(250px);
  opacity: 0;
}

</style>
